<template>
    <div>
        <a href="#" class="alink" color="success" @click="reset">
            <v-icon color="success">mdi-plus-circle</v-icon>Add New Subject
        </a>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="800px"
            transition="dialog-bottom-transition"
            v-if="newform">
            <v-card>
                <v-card-title class="modal-card-title text-h6 font-weight-bold">
                <v-icon left>mdi-book-open-variant</v-icon>
                <span v-if="!editBtn">Create Subject</span>
                <span v-else>Update Subject</span>
                <v-spacer></v-spacer>
                <v-btn icon class="modal-close-btn" @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                </v-card-title>

                <v-card-text class="pt-6">
                <v-form v-model="valid" ref="form">
                    <v-container>
                        <v-row>                                        
                            <v-col
                            cols="12"
                            md="6"
                            >
                                <v-text-field
                                    outlined
                                    v-model="form.subject"
                                    label="Subject Name"
                                    :rules="[v => !!v || 'Subject Name is required']"
                                    required
                                ></v-text-field>
                            </v-col>                                        
                            <v-col
                            cols="12"
                            md="6"
                            >
                                <v-text-field
                                    outlined
                                    v-model="form.display_position"
                                    label="Subject Order / Position"
                                    :rules="subjectOrderRules"
                                    required
                                    type="number" onwheel="this.blur()"
                                    min="1"
                                    max="30"
                                ></v-text-field>
                            </v-col>
                            <!-- <v-col
                            cols="12"
                            md="4"
                            >
                                <v-text-field
                                    outlined
                                    v-model="form.teacher_name"
                                    label="Subject Teacher Name"
                                ></v-text-field>
                            </v-col>  -->
                            <v-col
                            cols="12"
                            >
                                <v-select
                                    v-model="form.class_groups"
                                    outlined
                                    :items="classes"
                                    item-text="class"
                                    item-value="class_id"
                                    :rules="[v => !!v || 'Class/es is required']"
                                    label="Select Classes the subject belongs to"
                                    multiple
                                    required
                                ></v-select>
                            </v-col>                                        
                            <v-col
                            cols="12"
                            md="12"
                            >
                            <v-btn :disabled="!valid" color="success" rounded elevation="2"
                            class="mr-2 px-6" @click="postRecord" v-if="!editBtn"
                            >
                                <v-icon left>mdi-check</v-icon>
                                Create
                            </v-btn>
                            <v-btn :disabled="!valid" color="success" rounded elevation="2"
                            class="mr-2 px-6" @click="updateRecord" v-else
                            >
                                <v-icon left>mdi-check</v-icon>
                                Update
                            </v-btn>
                            <v-btn outlined rounded @click="closeDialog">
                                <v-icon left>mdi-close</v-icon>
                                Close
                            </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from 'axios';
  export default {
    name: 'CreateSubjectForm',
    props:[
        'authToken',
        'school',
        'subjects',
        'classes',
        'editFormRecord'
    ],
    
    data: () => ({
        newform: false,
        editBtn: false,
        form:{},
        valid: true,
        dialog:true,
        subjectOrderRules: [
            v => !!v || ' Subject Order is required'
        ],
    }),
    watch:{
        editFormRecord(record){
            this.editRecord(record)
        }
    },
    methods: {
        reset () {
            this.newform = true
            this.editBtn = false
            this.form = {}
        },
        closeDialog() {
            this.newform = false;
        },
        postRecord () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.post(process.env.VUE_APP_BASEURL+'/subjects?school_id='+this.school.school_id,this.form,
            {
                headers: 
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                }); 
                this.newform = false   
                this.$emit("refreshSignal", "yes"); // Emit the event with data or response           
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
        editRecord (record){
            this.newform = true
            this.form.id = record.subject_id
            this.form.teacher_name = record.teacher_name
            this.form.display_position = parseInt(record.display_position)
            this.form.subject = record.subject
            this.form.class_groups = record.class.map((a)=>{return Number(a.class_id)})
            this.editBtn = true
        },
        updateRecord () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.put(process.env.VUE_APP_BASEURL+'/subjects/'+this.form.id+'?school_id='+this.school.school_id,this.form,
            {
                headers: 
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                }); 
                this.editBtn = false             
                this.newform = false 
                this.$emit("refreshSignal", "yes"); // Emit the event with data or response            
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        }
    },
  }
</script>
<style scoped>
.alink{
    text-decoration: none;
    font-weight: bolder;
}
</style>